import AddSeedToStation from './AddSeedToStation';
import DeleteSeedFromStation from './DeleteSeedFromStation';
import RemoveFromLibrary from './RemoveFromLibrary';
import UpdateStationDetails from './UpdateStationDetails';

export const Templates = Object.freeze({
  AddSeedToStation,
  DeleteSeedFromStation,
  RemoveFromLibrary,
  UpdateStationDetails,
} as const);
